// For Repository Workflow
import type { AsyncData } from '#app';
import type { IModelResponse } from '~/services/base/dto/base.dto';
import type { IModelGETWorkflowRuntimeIdResponse, IModelGETWorkflowRuntimeRequest, IModelPOSTWorkflowRuntimeRequest, IModelPUTWorkflowRuntimeRequest, ModelGETWorkflowRuntime } from './dto/workflow.dto';

export class WorkflowRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService;
  }

  async getWorkflowRuntime(params: IModelGETWorkflowRuntimeRequest): Promise<AsyncData<IModelResponse<ModelGETWorkflowRuntime[]>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/workflow-runtime`, this.configService, {
      params
    });
    return dataResult;
  }

  async getWorkflowRuntimeId(id: string | number): Promise<AsyncData<IModelResponse<IModelGETWorkflowRuntimeIdResponse>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/workflow-runtime/${id}`, this.configService);
    return dataResult;
  }

  async postWorkflowRuntime(params: IModelPOSTWorkflowRuntimeRequest): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/workflow-runtime`, this.configService, {
      method: 'POST',
      body: {
        data: params,
      }
    });
    return dataResult;
  }

  async putWorkflowRuntime(params: IModelPUTWorkflowRuntimeRequest): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/workflow-runtime`, this.configService, {
      method: 'PUT',
      body: {
        data: params,
      }
    });
    return dataResult;
  }

  async deleteWorkflowRuntime(id: string | number): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/workflow-runtime/${id}`, this.configService, {
      method: 'DELETE'
    });
    return dataResult;
  }
}
